module.exports = __webpack_public_path__ + "static/img/app-qr-code-2022.aaab9ad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/app-qr-code-2022.png
// module id = ZIXq
// module chunks = 4